import targetIcon from '@/img/map-markers/target.png';
import pinIcon from '@/img/map-markers/pin.png';

export default {
    target: targetIcon,
    pin: pinIcon,
};
